module.exports = __webpack_public_path__ + "static/media/inverterQuestion.85bbd671.png";